import { render } from "./Maininput.vue?vue&type=template&id=40bd97be&scoped=true"
import script from "./Maininput.vue?vue&type=script&lang=js"
export * from "./Maininput.vue?vue&type=script&lang=js"

import "./Maininput.vue?vue&type=style&index=0&id=40bd97be&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bd97be"]])

export default __exports__